<template>
    <div id="home">
        <div class="ribbon"></div>
        <div class="pad-top">
            <v-card class="mx-auto"
                    max-width="500">
                <v-card-title class="justify-center">Mot de passe oublié</v-card-title>

                <v-container>
                    <v-text-field v-model="email" label="Email" id="email" name="email" outlined></v-text-field>

                    <div class="text-center">
                        <v-btn class="default-button"
                               :disabled="email === null || email === ''"
                               @click="requestForgetPassword">
                            Envoyer
                        </v-btn>

                        <v-alert color="success" type="success" class="mt-5" v-if="sent">
                            Un lien de réinitialisation de mot de passe a été envoyé à l'adresse <b>{{ sentEmail }}</b>
                        </v-alert>

                        <div class="mt-4">
                            <router-link to="/">Se connecter autrement</router-link>
                        </div>
                    </div>
                </v-container>
            </v-card>
        </div>
    </div>
</template>

<script>
export default {
    name: "ForgetPassword",
    data() {
        return {
            email: null,
            sentEmail: null,
            sent: false
        }
    },
    methods: {
        requestForgetPassword() {
            let payload = {
                email: this.email
            }

            this.$global.loading = true

            this.$http.post('auth/forget-password/request', payload).then(res => {
                this.$global.loading = false

                if(res.body.success) {
                    this.sentEmail = JSON.parse(JSON.stringify(this.email))
                    this.sent      = true
                }
            })
        }
    }
}
</script>